import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Arrow from './arrow';
import { media } from '../../utils/media-queries';

export const Publication = ({ title, href, subline }) => {
  const [active, setActive] = useState(false);

  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <StyledLink
        onMouseEnter={() => setActive(true)}
        onMouseLeave={() => setActive(false)}
      >
        <p className="subline">{subline}</p>
        <div className="wrap">
          <div className="alink">
            <p>{title}</p>
          </div>
          <Arrow className="arrow link" active={active} />
        </div>
      </StyledLink>
    </a>
  );
};

const StyledLink = styled.button`
  width:100%;
  text-align: left;
  color: var(--black);

  padding-top: var(--sp-1);
  padding-bottom: var(--sp-5);
  border-bottom: 1px solid #D2D2D2;
  p {
    transition:all 250ms ease-out;
  }
  &:hover p {
    color:var(--red);
  }

  .wrap {
    display: flex;
  justify-content:space-between;
  }

  .subline {
    color: var(--red);
    font-size: var(--fs-small);
    padding-bottom: var(--sp-1);
  }

  .arrow {
    position: static;
    display: inline-block;

    svg {
      transform: translateY(0px);
    }
  }

  .alink {
    width:80%;
    display: inline-block;
  }
`;

Publication.propTypes = {
  title: PropTypes.string,
  href: PropTypes.string,
};
